import { render, staticRenderFns } from "./GradePostCreate.vue?vue&type=template&id=e35d3664&scoped=true"
import script from "./GradePostCreate.vue?vue&type=script&lang=js"
export * from "./GradePostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35d3664",
  null
  
)

export default component.exports